const RestrictedSettingRoute = ({
  children,
  isOrgSettings,
  isOrgRestricted,
  history,
  defaultPath
}) => {
  if (isOrgRestricted && isOrgSettings) {
    history.push({
      pathname: `${defaultPath}?isOrgSettings=true`
    });
    return null;
  }

  return children;
};

export default RestrictedSettingRoute;
